<!-- Conversación de Mensajes -->
<div class="incidence-timeline-header" animate.enter="loaded-fade-enter">
  <h3>Historial de acciones</h3>
  <div class="header-actions">
    <button type="button" (click)="fixAddMessageToBottom()" [ngClass]="{'btn-lead': isAdmin,'btn btn-primary': !isAdmin}" class="btn-sm"><i aria-hidden="true" class="fa fa-plus"></i> Añadir mensaje</button>
  </div>
</div>

@if (messages && messages.length > 0) {
<ul class="incidence-timeline">
  @for (message of messages; track message.IdData) {
  <li [class]="getMessageClass(message)" animate.enter="loaded-fade-enter">
    <div class="message-data">
      <span>{{ getTimeAgo(message.CreationDate) }}</span>
      <span>{{ message.CreationDate }}</span>
      <div class="message-sender">
        <span><strong>{{ getMessageLabel(message) }}</strong></span>
        @if (message.UserName && (message.MessageFromUser || isAdmin)) {
        <span class="message-author">
          {{ message.UserName }}
        </span>
        }
      </div>
    </div>
    <div class="message-type-icon"></div>
    <div class="message-bubble">
      @if (isAdmin && !message.MessageFromUser && isEditingMessage(message)) {
      <div class="message-form" id="edit-message" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
        <angular-editor [config]="editorConfig" [(ngModel)]="editedMessageContent"></angular-editor>
        <div class="row mt-2">
          <div class="col-xl-6 mb-3">
            <div class="form-group">
              <label class="form-label mb-1">Archivo adjunto</label>
              <ngx-dropzone class="rounded-0 mb-sm-2" id="dzEditFile" (change)="onEditFileAttachedSelect($event)" [multiple]="false">
                <ngx-dropzone-label class="bg-cropper_label">
                  Arrastra o selecciona el archivo
                </ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of editFileAttachedFiles" [file]="f" [removable]="true" (removed)="onEditFileAttachedRemove(f)">
                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
          </div>
          <div class="col-xl-6 mb-3 pt-2 text-end">
            <div class="cont_switches justify-end mb-3 me-3">
              <div class="cont__switch-group">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="editIsInternalCheck" [(ngModel)]="editedIsInternal">
                  <label class="form-check-label" for="editIsInternalCheck">Mensaje Interno</label>
                </div>
                @if (editedIsInternal) {
                <small class="form-text text-muted" animate.enter="loaded-height-enter">
                  Los mensajes internos solo son visibles para los administradores y gestores.
                </small>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="email-status-container mt-0">
          <div class="email-status-row">
            <ng-container *ngTemplateOutlet="emailStatus; context: { message: message, withoutBorder: true }">
            </ng-container>
            <div class="email-status-actions">
              <button type="button" class="btn-outline-black btn-sm" (click)="cancelEdit()"><i class="fa-solid fa-xmark"></i>Cancelar</button>
              <button type="button" class="btn-lead btn-sm" (click)="saveEdit()"><i class="fa-solid fa-save"></i>Guardar</button>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div class="message-text" [innerHTML]="message.Message" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave"></div>
      @if (showSignature(message)) {
      <div class="message-signature" [innerHTML]="signature"></div>
      }
      }
      @if (message.FileAttached) {
      <div class="message-attachment">
        @if (isImageFile(message.FileAttached)) {
        <div class="image-preview-container">
          <div class="image-preview-wrapper">
            <a role="button" (click)="openPreviewModal(message.FileAttached.FileName,message.FileAttached.FileUri,message.FileAttached.FileSize)" class="image-link">
              <img [src]="message.FileAttached.FileUri" [alt]="message.FileAttached.FileName" class="preview-image" (error)="$event.target.style.display='none'">
            </a>
            @if (isAdmin && !message.MessageFromUser){
            <ng-container *ngTemplateOutlet="attachmentDeleteButton; context: { message: message }">
            </ng-container>
            }
          </div>
          <div class="image-info">
            <div class="image-details">
              <a [href]="message.FileAttached.FileUri" target="_blank" class="attachment-link">
                <i class="fa-solid fa-image"></i>
                <span class="file-name">{{ message.FileAttached.FileName }}</span>
                <span class="file-size">({{ formatFileSize(message.FileAttached.FileSize) }})</span>
              </a>
            </div>
          </div>
        </div>
        } @else {
        <a [href]="message.FileAttached.FileUri" target="_blank" class="attachment-link">
          <i class="fa-solid fa-paperclip"></i>
          {{ message.FileAttached.FileName }}
          <span class="file-size">({{ formatFileSize(message.FileAttached.FileSize) }})</span>
        </a>
        @if (isAdmin && !message.MessageFromUser){
        &nbsp;
        <ng-container *ngTemplateOutlet="attachmentDeleteButton; context: { message: message }">
        </ng-container>
        }
        }
      </div>
      }
      @if (isAdmin && !message.MessageFromUser && !isEditingMessage(message)) {
      <ng-container *ngTemplateOutlet="emailStatus; context: { message: message }">
      </ng-container>
      }
    </div>
  </li>
  }
</ul>
} @else {
<div class="no-messages" animate.enter="loaded-fade-enter">
  <p>No hay mensajes en esta consulta.</p>
</div>
}

<!-- Modal ng-bootstrap -->
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Previsualización</h4>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="image-preview-container">
          <div class="image-preview-wrapper">
            <img [src]="modalPreviewFileUri" [alt]="modalPreviewFileName" class="preview-image">
          </div>
        </div>
      </div>
      <div class="col-12">
        <a [href]="modalPreviewFileUri" target="_blank" class="attachment-link">
          <i class="fa-solid fa-image"></i>
          <span class="file-name">{{ modalPreviewFileName }}</span>
          <span class="file-size">({{ formatFileSize(modalPreviewFileSize) }})</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emailStatus let-message="message" let-withoutBorder="withoutBorder">
  <div class="email-status-container" [ngClass]="{
    'border-0 pt-0 mt-0': withoutBorder
  }">
    <div class="email-status-row">
      @if(!message.IsInternal){
      @if (isLoadingEmailStatus(message.IdData)) {
      <div class="email-status-loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Cargando estado del email...</span>
      </div>
      } @else {
      @let emailStatus = getEmailStatusForMessage(message);
      @if (emailStatus) {
      <div class="email-status-info">
        <div class="email-status-items">
          <strong>Estados email</strong>
          <div class="email-status-item" [class.status-success]="emailStatus.EmailSent" [class.status-pending]="!emailStatus.EmailSent">
            <i class="fa-solid" [class.fa-check-circle]="emailStatus.EmailSent" [class.fa-clock]="!emailStatus.EmailSent"></i>
            <span>{{ emailStatus.EmailSent ? 'Enviado' : 'Pendiente' }}</span>
            @if (emailStatus.EmailSent && emailStatus.EmailSentDate) {
            <span class="email-status-date">{{ emailStatus.EmailSentDate }}</span>
            }
          </div>
          <div class="email-status-item" [class.status-success]="emailStatus.EmailOpened" [class.status-pending]="emailStatus.EmailSent && !emailStatus.EmailOpened" [class.status-disabled]="!emailStatus.EmailSent">
            <i class="fa-solid" [class.fa-eye]="emailStatus.EmailOpened" [class.fa-eye-slash]="!emailStatus.EmailOpened"></i>
            <span>{{ emailStatus.EmailOpened ? 'Abierto' : 'Sin abrir' }}</span>
            @if (emailStatus.EmailOpened && emailStatus.EmailOpenedDate) {
            <span class="email-status-date">{{ emailStatus.EmailOpenedDate }}</span>
            }
          </div>
          <div class="email-status-item" [class.status-success]="emailStatus.EmailClicked" [class.status-pending]="emailStatus.EmailOpened && !emailStatus.EmailClicked" [class.status-disabled]="!emailStatus.EmailOpened">
            <i class="fa-solid fa-hand-pointer"></i>
            <span>{{ emailStatus.EmailClicked ? 'Se ha hecho clic' : 'No se ha hecho clic' }}</span>
            @if (emailStatus.EmailClicked && emailStatus.EmailClickedDate) {
            <span class="email-status-date">{{ emailStatus.EmailClickedDate }}</span>
            }
          </div>
        </div>
      </div>
      }
      }
      }
      <div class="email-status-actions">
        @if (!isEditingMessage(message)) {
        <button type="button" class="btn-option btn-option-edit" (click)="editMessage(message)" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Editar mensaje"><span class="visually-hidden">Editar mensaje</span></button>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #attachmentDeleteButton let-message="message">
  <button type="button" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Eliminar archivo adjunto" class="btn-option btn-option-delete" (click)="deleteFileAttached(message)"><span class="visually-hidden">Eliminar archivo adjunto</span></button>
</ng-template>